import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const TechnologiesInfoWrapper = styled('div')<{ theme?: TTheme }>`
    display: grid;
    grid-template-columns: 50% 50%;
    border-top: 4px solid
        ${({ theme: { colors } }) => colors.semantic.drawerSeparator};

    .section-title {
        margin: 24px 0;
        grid-column: 1 / span 2;
        color: ${({ theme: { colors } }) => colors.greys[800]};
    }

    .technology-item {
        margin-bottom: 4px;
    }
`

export const IconWrapper = styled('div')`
    width: 24px;
    aspect-ratio: 1;
`

export const TechnologyItem = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme: { colors } }) => colors.greys[800]};

    .asm-icon {
        width: 24px;
        aspect-ratio: 1;
    }
`
